/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as addReservedHandle from './temp/addReservedHandle.js'
export * as checkHandleAvailability from './temp/checkHandleAvailability.js'
export * as checkSignupQueue from './temp/checkSignupQueue.js'
export * as dereferenceScope from './temp/dereferenceScope.js'
export * as fetchLabels from './temp/fetchLabels.js'
export * as requestPhoneVerification from './temp/requestPhoneVerification.js'
export * as revokeAccountCredentials from './temp/revokeAccountCredentials.js'
